import _ from "lodash";

import { reduceList, reduceListExtra } from "./utils";
import { newCollectionItem } from "../../scheduler/index";

const base = "https://us-central1-evolve-f8968.cloudfunctions.net";
const tweet_info = `${base}/twitter-tweet`;
const getJson = res => res.json();

const getTweet = id => fetch(tweet_info + "?id=" + id).then(getJson);

const makeTweet = (text, userName, userLogo) => {
  return {
    text: { type: "text", value: text },
    userName: { type: "text", value: userName },
    userLogo: { type: "image", value: userLogo }
  };
};

export default (params, id, cb) => {
  getTweet(params.tweetId).then(data =>
    cb(makeTweet(data.text, data.user.name, data.user.profile_image_url_https))
  );
};

var feedInterval = undefined;
var tweets = [];
export const feed = (params, id, cb) => {
  if (!feedInterval) {
    var evtSource = new EventSource("https://api.tweetalerts.tv/stream/hudslive", {
      withCredentials: true
    });

    feedInterval = true;

    const keyType = {
      avatar: "image"
    };
    evtSource.onmessage = function(e) {
      const json = JSON.parse(e.data);
      //data true is an heartbit so we can ignore it
      if (json.data !== true) {
        tweets = _.take([json.data].concat(tweets), 10);
        const collName = id + ".tweets";
        newCollectionItem({
          item: {
            ..._.mapKeys(json.data, (v, k) => collName + "." + k),
            [collName + ".__id"]: json.data.id
          },
          collection: collName
        });
        cb(
          {
            tweets: reduceList(tweets, "id", true)
          },
          reduceListExtra(
            tweets,
            "id",
            c =>
              _.mapValues(c, (p, k) => {
                return { type: keyType[k] || "text", value: p };
              }),
            "twitterfeed.tweets"
          )
        );
      }
    };
  }
};



// WEBPACK FOOTER //
// ./src/spreadsheet/providers/twitter.js